import {Component} from '@angular/core';
import {firstValueFrom} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.css'],
    standalone: false
})
export class ThankYouComponent {
  eventID = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}
  async ngOnInit() {
    try {
      const params = await firstValueFrom(this.route.paramMap);
      const ref = params.get('id');

      if (ref != null) {
        this.eventID = ref;
      }
    } catch (e) {
      console.log(e);
    }
  }
}
